import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/new-design/images/upload-icon.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Upload Files", -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" Drop file here or "),
  /*#__PURE__*/_createElementVNode("em", null, "click to upload")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " Files must have a size of less than 5mb ", -1)
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = ["data-kt-indicator"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cloud-upload-alt text-white" }),
  /*#__PURE__*/_createTextVNode(" Upload ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }),
  /*#__PURE__*/_createTextVNode(" Uploading... ")
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog) = $event)),
    width: "600px",
    ref: "fileUploader"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_upload, {
            class: "upload-demo",
            ref: "uploader",
            drag: "",
            "file-list": _ctx.fileList,
            "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
            "auto-upload": false,
            multiple: "",
            "on-change": _ctx.onChange,
            "on-remove": _ctx.handleRemove,
            "on-success": _ctx.handleSuccess
          }, {
            tip: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }, 8, ["file-list", "on-change", "on-remove", "on-success"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          "data-kt-indicator": _ctx.loadState ? 'on' : null,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFiles && _ctx.uploadFiles(...args))),
          class: "btn btn-new-design-primary"
        }, _hoisted_11, 8, _hoisted_8)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}